<template>
<div>
	<el-card class="box-card">
		<!-- <div slot="header" class="flex-be">
			<div class="search_condition">
				<el-date-picker class="m-r-10" size="small" v-model="dateTime" type="datetimerange"
					value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" @change="changeTime">
				</el-date-picker>

				<el-select size="small" v-model="status" placeholder="请选择" class="search_condition_item"
					@change="getDataFn">
					<el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
		</div> -->
		<div class="content_table">
			<el-table  :data="configTable.tableData" :loading="configTable.loading"
				@handleClick="handleClick" @selectChange="handleSelectionChangeFn"
				@handleSelectionChange="handleSelectionChangeFn">
				<el-table-column prop="taskName" label="任务名称" align="center"> </el-table-column>
				<el-table-column prop="dataCatalogueName" label="数据目录名称" align="center"></el-table-column>
				<el-table-column prop="dataLevelName" label="数据级别名称" align="center"></el-table-column>
				<el-table-column prop="categoryName" label="类型名称" align="center"> </el-table-column>
				<el-table-column prop="username" label="申请人" align="center"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
				<el-table-column label="审核情况">
					<template slot-scope="scope">
						{{ scope.row.status==0?'待审核':scope.row.status== 1?' 审核通过':'审核不通过' }}
                    </template>
				</el-table-column>
				<el-table-column prop="reason" label="原因" align="center" width="200"></el-table-column>

				
			</el-table>
			<el-empty v-if="configTable.tableData.length <= 0" description="暂无数据"></el-empty>
		</div>
		<div class="flex-be m-t-20">
			<!-- <el-button size="small" type="primary" @click="batchDeletionFn">批量删除</el-button> -->
			<el-pagination @current-change="getDataFn" @size-change="handleSizeChange"
				:current-page.sync="configTable.current" layout="total, sizes, prev, pager, next, jumper" background
				:page-sizes="[10, 15, 20]" :page-size="configTable.pageSize" :total="configTable.total"></el-pagination>
		</div>
	</el-card>
</div>
</template>

<script>
import tableTotal from "@/components/TableTotal/TableTotal";

export default {
	name: "favoritesList",
	// import引入的组件需要注入到对象中才能使用
	components: {
		tableTotal
	},
	filters: {
		filter(value) {
			if (!value) {
				return '-'
			}
			if (!value.goodsSpec) {
				return '-'
			}
			if (value.goodsSpec[0] === '{') {
				let str = value.goodsSpec.slice(1, value.goodsSpec.length - 1)
				return str.replace(/,/g, ',').replace(/"/g, '').replace(/:/g, ' : ')
			}
		}
	},
	data() {
		// 这里存放数据
		return {
			dateTime: '',
			status: 0,
			statusList: [
				{ value: 0, label: '全部状态', },
				{ value: 1, label: '上架', },
				{ value: 2, label: '下架', },
			],
			// 配置表格
			configTable: {
				loading: false,
				indexShow: false,
				configData: [
					{
						type: 'selection'
					},
					{
						value: 'goodPic',
						label: '商品图片',
						width: 150,
						align: 'left',
						type: 'img'
					},
					{
						value: 'goodName',
						label: '商品名称',
						align: 'center'
					},
					{
						value: 'value',
						label: '商品详情',
						width: 220,
						align: 'left',
						type: "custom",
						customName: "goodInfo"
					},
					{
						value: 'shelfStatus',
						label: '状态',
						align: 'center',
						objList: { //
							1: '上架',
							2: '下架',
						}
					},
					{
						value: 'goodPrice',
						label: '金额',
						align: 'center',
						type: "custom",
						customName: "productPrice"
					},
					{
						value: 'createTime',
						label: '下单时间',
						align: 'center',
						type: 'timeDate'
					},
					{
						label: '操作', width: '120', fixed: 'right', type: 'handleList', buttonList: [
							{ label: '查看', event: 'seeData', show: true, showText: true },
							{
								label: '删除', event: 'delete', show: true, showText: true,
								text: '确定删除该收藏?',
							},
						]
					}
				],
				tableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10
			},
			tableSelect: []
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	mounted() {
		this.info();
	},
	// 方法集合
	methods: {
		info() {
			// 获取数据
			this.getDataFn();
		},
		changeTime() {
			this.configTable.current = 1;
			this.getDataFn();
		},
		async getDataFn() {
			let params = {
				startTime: this.dateTime ? this.dateTime[0] : '',
				endTime: this.dateTime ? this.dateTime[1] : '',
				pageNum: this.configTable.current,
				pageSize: this.configTable.pageSize,
			};
			try {
				this.configTable.loading = true;
				let res = await this.$http.get(this.$const.personalCenter.catalogueReviewList, params);
				if (res && res.rows) {
					console.log(res);
					this.configTable.tableData = res.rows;
					this.configTable.total = res.total;
					this.configTable.loading = false;
				}
			} catch (e) {
				this.configTable.loading = false;
				// console.log(e);
			}
		},
		async handleClick(event, data, text) {
			switch (event) {
				case 'seeData':
					this.$router.push({ name: "productDetail", params: { id: data.goodId}});
					break;
				case 'delete':
					this.$confirm(text, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
						.then(async () => {
							let p = {
								collectId: data.id
							};
							await this.collectDeleteFn(p);
						});
					break;
			}
		},
		async collectDeleteFn(data) {
			try {
				let res = await this.$http.delete(this.$const.personalCenter.collectDelete, data);
				if (res && res.code === 200) {
					// console.log(res);
					this.$message.success(this.$PubText.successCom);
					this.getDataFn();
				}
			} catch (e) {
				// console.log(e);
			}
		},
		handleSizeChange(val) {
			this.configTable.pageSize = val;
			this.getDataFn();
		},
		// 表格多选 全选
		handleSelectionChangeFn(data) {
			this.tableSelect = data;
		},
		batchDeletionFn() {
			if (this.tableSelect.length <= 0) {
				this.$message.warning(this.$PubText.multipleTip);
				return;
			}
			const ids = this.tableSelect.map((item) => {
				return item.id
			});
			let p = {
				collectId: ids.toString()
			};
			this.collectDeleteFn(p);
		},
	},
}
</script>

<style lang="scss" scoped>
.search_condition_item {
	width: 140px;
}

.pagination_box {
	text-align: right;
}
</style>
